import { render, staticRenderFns } from "./Formulario.vue?vue&type=template&id=02deee62&"
import script from "./Formulario.vue?vue&type=script&lang=ts&"
export * from "./Formulario.vue?vue&type=script&lang=ts&"
import style0 from "./Formulario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports